import React from 'react';
import { LineChart as RechartsLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { ChartProps } from '../../types/visualization';
import CustomTooltip from '../common/CustomTooltip';

const LineChart: React.FC<ChartProps> = ({ data, config, colors = ['#3b82f6', '#ef4444', '#10b981'] }) => {
  if (!data || data.length === 0) {
    return <div>No data available</div>;
  }

  const xAxisColumn = config?.xAxis?.column || Object.keys(data[0])[0];
  const yAxisColumns = config?.yAxis?.primary?.columns || Object.keys(data[0]).filter(key => key !== xAxisColumn);

  // Format data for Recharts
  const formattedData = data.map(item => {
    const formatted = { [xAxisColumn]: item[xAxisColumn] };
    yAxisColumns.forEach(col => {
      formatted[col] = Number(item[col]) || 0;
    });
    return formatted;
  });


  return (
    <div style={{ width: '100%', height: '400px' }}>
      <ResponsiveContainer width="100%" height="100%">
        <RechartsLineChart data={formattedData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey={xAxisColumn}
            tick={{ fontSize: 12 }}
            angle={data.length > 8 ? -45 : 0}
            textAnchor={data.length > 8 ? 'end' : 'middle'}
            height={data.length > 8 ? 80 : 60}
          />
          <YAxis 
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => value.toLocaleString()}
          />
          <Tooltip 
            content={<CustomTooltip 
              config={config} 
              xAxisLabel={config?.xAxis?.label || 'X'} 
              currencyFormat={config?.yAxis?.primary?.format === 'currency'}
            />} 
          />
          <Legend />
          
          {yAxisColumns.map((column, index) => (
            <Line
              key={column}
              type="monotone"
              dataKey={column}
              name={config?.yAxis?.primary?.labels?.[index] || column.replace(/_/g, ' ')}
              stroke={colors[index] || colors[0]}
              strokeWidth={2}
              dot={{ fill: colors[index] || colors[0], strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6 }}
            />
          ))}
        </RechartsLineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChart; 